import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ onFadeComplete, isFadingOut }) => {
  const [isFading, setIsFading] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (isFadingOut) {
      setIsFading(true);
      // Wait for the fade-out animation to complete before removing from DOM
      setTimeout(() => {
        setIsVisible(false);
        if (onFadeComplete) onFadeComplete();
      }, 500); // Match the transition duration
    }
  }, [isFadingOut, onFadeComplete]);

  if (!isVisible) return null;

  return (
    <div className={`loading-screen ${isFading ? 'fade-out' : ''}`}>
      <div className="loading-spinner"></div>
      <p>Загрузка...</p>
    </div>
  );
};

export default LoadingScreen; 